import axios from "axios";

export const trackPageVisit = async () => {
  try {
    // Dynamically grab the domain and path from the browser
    const currentDomain = window.location.hostname; // e.g., "app.hypertrace.io"
    const currentPath = window.location.pathname;   // e.g., "/" or "/admin/default"

    // Use your existing external API endpoint
    await axios.post("https://hypertrace.io/chat-api/track-visit", {
      domain: currentDomain,
      path: currentPath,
    });
    
    console.log(`Visit tracked: ${currentDomain}${currentPath}`);
  } catch (error) {
    // Fail silently so it doesn't disrupt the user experience
    console.error("Failed to track visitor:", error);
  }
};